import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetAssetTicketStats = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/tickets-data';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetAssetTicketStats;
